import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelSelect as _vModelSelect, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "filter-bar d-flex flex-wrap align-items-end gap-3 py-2" }
const _hoisted_2 = {
  class: "filter-field",
  style: {"min-width":"180px"}
}
const _hoisted_3 = {
  class: "filter-field",
  style: {"min-width":"180px"}
}
const _hoisted_4 = {
  class: "filter-field",
  style: {"min-width":"180px"}
}
const _hoisted_5 = {
  class: "filter-field",
  style: {"min-width":"180px"}
}
const _hoisted_6 = {
  key: 0,
  class: "filter-field",
  style: {"min-width":"180px"}
}
const _hoisted_7 = {
  key: 1,
  class: "filter-field",
  style: {"min-width":"180px"}
}
const _hoisted_8 = {
  class: "filter-field",
  style: {"min-width":"140px"}
}
const _hoisted_9 = { class: "filter-field" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_icon_close = _resolveComponent("icon-close")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[8] || (_cache[8] = _createElementVNode("label", { class: "form-label mb-1" }, "Cerca per nome", -1)),
      _withDirectives(_createElementVNode("input", {
        type: "text",
        class: "form-control",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.localValue.name) = $event)),
        placeholder: "Nome..."
      }, null, 512), [
        [_vModelText, _ctx.localValue.name]
      ])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _cache[9] || (_cache[9] = _createElementVNode("label", { class: "form-label mb-1" }, "Descrizione", -1)),
      _withDirectives(_createElementVNode("input", {
        type: "text",
        class: "form-control",
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.localValue.description) = $event)),
        placeholder: "Descrizione..."
      }, null, 512), [
        [_vModelText, _ctx.localValue.description]
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _cache[10] || (_cache[10] = _createElementVNode("label", { class: "form-label mb-1" }, "Info", -1)),
      _withDirectives(_createElementVNode("input", {
        type: "text",
        class: "form-control",
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.localValue.info) = $event)),
        placeholder: "Info..."
      }, null, 512), [
        [_vModelText, _ctx.localValue.info]
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _cache[11] || (_cache[11] = _createElementVNode("label", { class: "form-label mb-1" }, "Note", -1)),
      _withDirectives(_createElementVNode("input", {
        type: "text",
        class: "form-control",
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.localValue.note) = $event)),
        placeholder: "Note..."
      }, null, 512), [
        [_vModelText, _ctx.localValue.note]
      ])
    ]),
    (_ctx.$store.state.isCommessaEditor())
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _cache[12] || (_cache[12] = _createElementVNode("label", { class: "form-label mb-1" }, "Creato da", -1)),
          _withDirectives(_createElementVNode("input", {
            type: "text",
            class: "form-control",
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.localValue.createdBy) = $event)),
            placeholder: "Nome utente..."
          }, null, 512), [
            [_vModelText, _ctx.localValue.createdBy]
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.$store.state.isCommessaEditor())
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
          _cache[13] || (_cache[13] = _createElementVNode("label", { class: "form-label mb-1" }, "Modificato da", -1)),
          _withDirectives(_createElementVNode("input", {
            type: "text",
            class: "form-control",
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.localValue.modifiedBy) = $event)),
            placeholder: "Nome utente..."
          }, null, 512), [
            [_vModelText, _ctx.localValue.modifiedBy]
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_8, [
      _cache[15] || (_cache[15] = _createElementVNode("label", { class: "form-label mb-1" }, "Stato", -1)),
      _withDirectives(_createElementVNode("select", {
        class: "form-control",
        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.localValue.isActive) = $event))
      }, _cache[14] || (_cache[14] = [
        _createElementVNode("option", { value: null }, "— Tutti —", -1),
        _createElementVNode("option", { value: true }, "Attivi", -1),
        _createElementVNode("option", { value: false }, "Inattivi", -1)
      ]), 512), [
        [_vModelSelect, _ctx.localValue.isActive]
      ])
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("button", {
        class: "btn btn-outline-secondary",
        onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.reset && _ctx.reset(...args)))
      }, [
        _createVNode(_component_icon_close),
        _cache[16] || (_cache[16] = _createTextVNode(" Reset "))
      ])
    ])
  ]))
}